import { render, staticRenderFns } from "./Dashbord1.vue?vue&type=template&id=202628f3&"
import script from "./Dashbord1.vue?vue&type=script&lang=js&"
export * from "./Dashbord1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports